(ns builder.sdc.browser
  (:require [re-frame.core :as rf]))

(ns sdc.browser
  "This namespace is for browser-specific functions, re-frame effects.
  Please use :browser namespaced keys for re-frame effects, co-effects and subscriptions."
  (:refer-clojure :exclude [parents])
  (:require [re-frame.core :as rf]))


(rf/reg-fx
  :browser/listen-post-message
  (fn [event-vector]
    #?(:cljs (.addEventListener js/window "message"
                                (fn [event]
                                  (let [data (js->clj (.-data event) :keywordize-keys true)]
                                    (rf/dispatch (conj event-vector data))))))))


(rf/reg-fx
  :browser/post-parent-message
  (fn [messages]
    #?(:cljs (when-let [top (.-top js/window)]
               (doseq [message messages]
                 (.postMessage top (clj->js message) "*"))))))


(rf/reg-fx
  :browser/post-iframe-message
  (fn [{:keys [iframe-id messages]}]
    #?(:cljs (when-let [window (some-> (js/document.getElementById iframe-id)
                                       (.-contentWindow))]
               (doseq [message messages]
                 (.postMessage window (clj->js message) "*"))))))

#?(:cljs
   (defn- host-window []
     (or (when-let [opener (.-opener js/window)]
           (when-not (.-closed opener) opener))
         (.-parent js/window))))

(rf/reg-fx
 :browser/post-host-message
 (fn [payload]
   #?(:cljs (when-let [host (host-window)]
              (let [{:keys [messages origin]} (if (and (map? payload) (contains? payload :messages))
                                                payload
                                                {:messages payload})
                    origin (or origin "*")]
                (doseq [message messages]
                  (.postMessage host (clj->js message) origin)))))))

(rf/reg-fx
 :browser/close-window
 (fn [_]
   #?(:cljs (js/window.close))
   )
 )


(defn confirm
  [message]
  #?(:cljs (js/confirm message)
     :clj  true))


(rf/reg-fx
 :browser/confirm
 (fn [{:keys [message event]}]
   (when (confirm message)
     (rf/dispatch event))))


(defn console-warn
  [& args]
  #?(:cljs (apply js/console.warn args)
     :clj  (apply println args)))


(defn location-reload []
  #?(:cljs (js/location.reload)))


(rf/reg-fx
  :browser/location-reload
  (fn [_]
    (location-reload)))


(defn parents
  [node]
  #?(:cljs
     (loop [node    node
            parents []]
       (when node
         (if (or (nil? node) (instance? js/HTMLDocument node))
           parents
           (recur (.-parentNode node) (conj parents node)))))))


(defn reload-iframe [id]
  #?(:cljs
     (let [iframe (.getElementById js/document id)]
       (.reload (.-location (.-contentWindow iframe))))))


(defn observe-height [element on-change]
  #?(:cljs
     (let [resize-observer (js/ResizeObserver.
                             (fn [entries]
                               (doseq [entry (js->clj entries :keywordize-keys true)]
                                 (on-change (.-clientHeight (.-target entry))))))]
       (.observe resize-observer element))))


(defn download-as-file
  [name content]
  #?(:cljs (let [blob        (js/Blob. #js [content] #js {:type "application/json"})
                 url         (js/URL.createObjectURL blob)
                 element     (js/document.createElement "a")]
             (set! (.-href element) url)
             (set! (.-download element) name)
             (js/document.body.appendChild element)
             (.click element)
             (js/URL.revokeObjectURL url)
             (js/document.body.removeChild element))))


(rf/reg-fx
  :browser/download-as-file
  (fn [{:keys [name content]}]
    (download-as-file name content)))


(rf/reg-event-fx
  :browser/download-as-file
  (fn [_ [_ name content]]
    {:browser/download-as-file {:name name :content content}}))


(defn fallback-copy-to-clipboard [text]
  #?(:cljs
     (js/Promise.
       (fn [resolve]
         (let [textarea (.createElement js/document "textarea")]
           (set! (.-value textarea) text)

           (set! (.-position (.-style textarea)) "fixed")
           (set! (.-top (.-style textarea)) "0")
           (set! (.-left (.-style textarea)) "0")
           (set! (.-width (.-style textarea)) "2em")
           (set! (.-height (.-style textarea)) "2em")
           (set! (.-padding (.-style textarea)) "0")
           (set! (.-border (.-style textarea)) "none")
           (set! (.-outline (.-style textarea)) "none")
           (set! (.-boxShadow (.-style textarea)) "none")
           (set! (.-background (.-style textarea)) "transparent")

           (.appendChild (.-body js/document) textarea)

           (.select textarea)
           (.setSelectionRange textarea 0 (.-length text))

           ;; Execute the copy command
           (let [result (try
                          (if (.execCommand js/document "copy") true)
                          (catch :default _ false))]
             (.removeChild (.-body js/document) textarea)
             (resolve result)))))))


(defn copy-to-clipboard [text]
  #?(:cljs
     (if (and js/navigator.clipboard js/navigator.clipboard.writeText)
       (-> (js/navigator.clipboard.writeText text)
           (.then (constantly true))
           (.catch #(fallback-copy-to-clipboard text)))
       (fallback-copy-to-clipboard text))))
